import { render, staticRenderFns } from "./renewView.vue?vue&type=template&id=64cfe64f"
import script from "./renewView.vue?vue&type=script&lang=js"
export * from "./renewView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports